import styled from "styled-components"
import { device } from "breakpoints"
import { getGradient } from "helpers/getGradient"
import { Teaser } from "components/Teaser"
import {
  ImageWrapper,
  InfoWrapper,
  Excerpt,
  InnerLink,
} from "components/Teaser/style"
import { SubtitleWrapper } from "components/ProjectStyles"

export const FeatureCarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${props => `${props.theme.componentMargin.mobile}px auto`};

  @media ${device.tablet} {
    flex-direction: row;
    padding: 0 30px;
  }
  @media ${device.desktop} {
    padding: 0;
    flex-direction: row;
    max-width: ${props => `${props.theme.mainMaxWidth}px`};
    width: ${props => `calc(100% - 2*${props.theme.desktopGutter}px)`};
    margin: ${props => `${props.theme.componentMargin.desktop}px auto`};
  }

  @media ${device.large} {
    margin: ${props => `${props.theme.componentMargin.large}px auto`};
  }

  .transitionGroup {
    position: relative;
    width: 100%;

    @media ${device.desktop} {
      width: 66.666666%;
    }
  }
`

export const ExtendedTitleWrapper = styled(SubtitleWrapper)`
  padding-right: 30px;
  padding-left: 30px;

  @media ${device.tablet} {
    padding: 0px;
  }
`
export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    width: 60.333333%;
    padding-right: 22px;
  }
  @media ${device.desktop} {
    width: 33.333333%;
    padding-right: 22px;
  }
`

export const ListWrapper = styled.div`
  /* overflow: hidden; */
`

export const List = styled.ul`
  display: flex;
  overflow: auto;
  flex-wrap: none;
  margin-left: -12px;
  margin-bottom: 30px;
  padding-left: 30px;
  list-style: none;

  ::-webkit-scrollbar {
    display: none !important;
  }
  @media ${device.tablet} {
    flex-direction: column;
    padding: 0;
    align-items: flex-start;
    margin-left: -14px;
  }

  li {
    position: relative;
    width: 100%;
    @media ${device.tablet} {
      padding: 7px 0;
    }
    @media ${device.desktop} {
      padding: 12px 0;
    }

    @media ${device.large} {
      padding: 14px 0;
    }
  }
`

export const ItemBtn = styled.button`
  border: none;
  background: none;
  padding: 0;
  white-space: pre;
  font-size: 14px;
  font-weight: 600;
  color: #4c4d58;
  text-transform: uppercase;
  /* outline: none; */
  border-radius: 24px;
  padding: 4px 12px;
  cursor: pointer;

  @media ${device.tablet} {
    font-size: 15px;
  }

  @media ${device.desktop} {
    text-align: left;
    font-size: 17px;
    padding: 4px 14px;
  }
  @media ${device.large} {
    font-size: 18px;
  }

  background-image: ${props => props.selected && getGradient(props.theme.site)};
  color: ${props => props.selected && "white"};

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
`

export const LargeTeaser = styled(Teaser)`
  @media ${device.desktop} {
    padding-left: 22px;
  }
  ${ImageWrapper} {
    padding-top: 66.66666%;
    margin-bottom: 20px;
    overflow: hidden;
    @media ${device.desktop} {
      margin-bottom: 30px;
    }
    @media ${device.large} {
      margin-bottom: 40px;
    }
  }
  ${InfoWrapper} {
    /* position: absolute;
    bottom: 0;
    transform: translateY(100%); */
    padding-left: 30px;
    padding-right: 30px;
    height: 170px;

    @media ${device.mobile} {
      height: 135px;
    }

    @media ${device.tablet} {
      padding: 0;
      height: 115px;
    }
    @media ${device.desktop} {
      height: 100px;
    }

    @media ${device.large} {
      height: 110px;
    }
  }

  ${Excerpt} {
    font-size: 16px;

    @media ${device.desktop} {
      font-size: 18px;
    }

    @media ${device.large} {
      font-size: 20px;
    }
  }
  /* border: 3px solid red; */

  &.fade-enter {
    img {
      transform: scale(1.1);
    }
  }

  &.fade-enter.fade-enter-active {
    img {
      transform: scale(1);
      transition: 850ms ease !important;
    }
  }

  &.fade-enter-done {
    img {
      transform: scale(1);
    }
  }

  &.fade-exit {
    img {
      transform: scale(1);
    }
  }

  &.fade-exit.fade-exit-active {
    img {
      transform: scale(1.1);
      transition: 850ms ease !important;
    }
  }

  &.fade-exit-done {
    img {
      transform: scale(1.1);
    }
  }

  ${InnerLink} {
    font-size: 16px;
    @media ${device.desktop} {
      font-size: 18px;
    }

    @media ${device.large} {
      font-size: 20px;
    }
    span:before {
      left: px;
    }
  }
`
